import { ExternalCategory, ExternalProduct } from 'common/types/entities/api/External'
import history, { getLocationPath } from 'common/history'
import { CommonState } from 'common/types'
import { fetchGrafolioCategories, fetchGrafolioProducts } from '../../services/external'
import { StateKey } from 'common/utils/flipState'
import { isPcEnv } from 'common/utils/common'
import { ArrayUtils } from '@shopping/common'

export interface ExternalParams {
  page: number
  sort?: string
  categoryNo?: string
  pageSize?: number
  first?: string
  append?: boolean
}

export interface ExternalProductsState {
  items: ExternalProduct[]
  params: ExternalParams
  hasMore: boolean
  loading: boolean
  infiniteGridStatus: any
  restoredByHistory: boolean
  categories: ExternalCategory[]
  flickingIndex?: number
}

const initialState: ExternalProductsState = {
  items: [],
  params: {
    page: 1,
    sort: 'REL_DES',
    pageSize: isPcEnv ? 40 : 20,
  },
  hasMore: false,
  loading: false,
  infiniteGridStatus: null,
  restoredByHistory: false,
  categories: [],
}

const FETCH = 'external/products/FETCH'
const INIT = 'external/products/INIT'
const SLICE_COMPOSITE_PRODUCT = 'external/products/SLICE_COMPOSITE_PRODUCT'
const FETCH_CATEGORY = 'external/products/FETCH_CATEGORY'
const SET_SORT = 'external/products/SET_SORT'
const SET_CATGORY = 'extenal/products/SET_CATGORY'
const SET_FLICKINGINDEX = 'external/products/SET_FLICKINGINDEX'

export const initExternalProducts = (curState: StateKey, queryParam: any) => async dispatch => {
  dispatch({
    curState,
    state: {
      ...initialState,
      ...queryParam,
    },
    type: INIT,
  })
}

export const getGrafolioProducts = (
  curState: StateKey,
  params: ExternalParams,
  isFirstFetch?: boolean,
  action?: string,
) => async (dispatch, getState: () => CommonState) => {
  const restoredState = getRestoredStateFromHistory()
  if (isFirstFetch && (action === 'POP' || action === undefined) && restoredState) {
    dispatch({
      curState,
      state: restoredState,
      type: FETCH,
    })
    return
  }

  const result = await fetchGrafolioProducts(params)
  const { items, hasMoreItem } = result
  const { page, pageSize, append } = params

  if (!page || !pageSize || !items) {
    return
  }

  const hasMore = items.length > pageSize
  let concatItems: ExternalProduct[] = hasMore ? items.slice(0, pageSize) : items
  concatItems.forEach(item => (item.groupKey = page))
  const prevState = getState().externalProducts[curState]

  if (!isFirstFetch && ArrayUtils.isNotEmpty(prevState.items)) {
    concatItems = append ? [...prevState.items, ...concatItems] : [...concatItems, ...(prevState.items || [])]
  }

  const state: ExternalProductsState = {
    params,
    items: concatItems,
    hasMore: hasMoreItem,
    loading: hasMoreItem,
    infiniteGridStatus: null,
    restoredByHistory: false,
    categories: prevState.categories ? prevState.categories : [],
    flickingIndex: prevState.flickingIndex ? prevState.flickingIndex : 0,
  }

  dispatch({
    curState,
    state,
    type: FETCH,
  })
  return
}

export const getRestoredStateFromHistory = (): ExternalProductsState => {
  if (history.location && history.location.state && history.location.state.externalState) {
    const state = {
      ...history.location.state.externalState,
      restoredByHistory: true,
    }
    history.replace(getLocationPath(history.location))
    return state
  }
  return null
}

export const storeSlicedCompositeList = (curState: StateKey, path, startKey, endKey, infiniteStatus) => async (
  dispatch,
  getState,
) => {
  const { externalProducts } = getState()
  const currentState: ExternalProductsState = externalProducts
  if (!currentState) return
  const sliceList = currentState.items.filter(item => item.groupKey >= startKey && item.groupKey <= endKey)

  const state = {
    ...currentState,
    infiniteGridStatus: infiniteStatus,
    items: sliceList,
    restoredByHistory: false,
  }

  history.replace(history.location.pathname + history.location.search + history.location.hash, { infinite: state })

  dispatch({
    curState,
    state,
    type: SLICE_COMPOSITE_PRODUCT,
  })
}

export const getGrafolioCategories = (curState: StateKey) => async (dispatch, getState) => {
  const categories = await fetchGrafolioCategories()

  dispatch({
    curState,
    categories,
    type: FETCH_CATEGORY,
  })
}

export const setCategory = (curState: StateKey, categoryNo: string) => async (dispatch, getState) => {
  const params = getState().externalProducts[curState].params
  dispatch({
    curState,
    params: {
      ...params,
      categoryNo,
    },
    type: SET_CATGORY,
  })
}

export const setSort = (curState: StateKey, sort: string) => async (dispatch, getState) => {
  const params = getState().externalProducts[curState].params
  dispatch({
    curState,
    params: {
      ...params,
      sort,
      page: 1,
    },
    type: SET_SORT,
  })
}

export const saveFlickingIndex = (curState: StateKey, flickingIndex: number) => async (dispatch, getState) => {
  dispatch({
    curState,
    flickingIndex,
    type: SET_FLICKINGINDEX,
  })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH:
    case SLICE_COMPOSITE_PRODUCT:
      return action.state
    case INIT:
      return {
        ...action.state,
      }
    case FETCH_CATEGORY:
      return {
        ...state,
        categories: action.categories,
      }
    case SET_SORT:
    case SET_CATGORY:
      return {
        ...state,
        params: action.params,
      }
    case SET_FLICKINGINDEX:
      return {
        ...state,
        flickingIndex: action.flickingIndex,
      }
    default:
      return state
  }
}

export default reducer
